module.exports = __webpack_public_path__ + "zappos-app-icon.1aedefdc9b39b39e47f4e3ddf33dcce3.png";